import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/audio.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import '@vidstack/react/player/styles/base.css';
import { useState } from "react";
import { MediaPlayer, MediaProvider, Poster } from "@vidstack/react";
import {
    DefaultVideoLayout,
    defaultLayoutIcons,
} from "@vidstack/react/player/layouts/default";
import VideoSkeleton from "./VideoSkeleton";
import VideoErrorPage from "./VideoErrorPage";
import { useParams } from "react-router-dom";
import { useVideoInformation } from "../hooks/useVideoInformation";
import { IoReload } from "react-icons/io5";

function Player() {
    const { courseId, lectureId, videoId } = useParams();
    const [refreshKey, setRefreshKey] = useState(0);

    const { isPending, videoInformation, isError, error } = useVideoInformation(
        { courseId, lectureId, videoId }
    );

    if (isPending) return <VideoSkeleton />;

    if (isError) return <VideoErrorPage error={error} />;

    const {
        attributes: { videoId: iframeId, videoInfo, provider },
    } = videoInformation.data;

    return (
        <>
            <div key={refreshKey}>

                <div dir="ltr">
                    { provider === "youtube" ? (
                        <MediaPlayer
                            src={`https://www.youtube-nocookie.com/${iframeId}`}
                            viewType="video"
                            streamType="on-demand"
                            logLevel="warn"
                            playsInline={true}
                            className="h-full aspect-video"
                            referrerPolicy="strict-origin-when-cross-origin"
                            style={{ contain: "layout" }}
                        >
                            <MediaProvider>
                                <Poster className="vds-poster" />
                            </MediaProvider>
                            <DefaultVideoLayout icons={defaultLayoutIcons} />
                        </MediaPlayer>
                    ) : (
                        <div
                            style={{ contain: "layout" }}
                            className="w-full h-full aspect-video [&>iframe]:w-full [&>iframe]:h-full [&>iframe]:aspect-video mb-1"
                            dangerouslySetInnerHTML={{ __html: videoInfo.embed_html }}
                        />
                    ) }
                </div>
            </div>
            <button
                onClick={() => setRefreshKey(prev => prev + 1)}
                className="flex items-center gap-3 px-4 py-2 text-white transition-all duration-75 rounded-md bg-blue-color-primary hover:bg-blue-950"
            >
                <IoReload width={10} height={10} />
                إعاده تحميل
            </button>
        </>
    );
}

export default Player;
